import { Instagram, Youtube, Mail, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 pt-24 pb-10 bg-graphite-950">
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-20">
          <div>
            <div className="overline mb-6">Contatti</div>
            <a
              href="mailto:Guzerat1998@gmail.com"
              data-testid="footer-email"
              className="group flex items-center gap-2 text-2xl md:text-3xl font-display font-medium hover:text-gold transition-colors"
            >
              Guzerat1998@gmail.com
              <ArrowUpRight strokeWidth={1.5} className="w-6 h-6 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
          </div>
          <div>
            <div className="overline mb-6">Servizi</div>
            <ul className="space-y-3 text-white/70">
              <li>Reel & TikTok</li>
              <li>Video promozionali</li>
              <li>Matrimoni & Eventi</li>
              <li>Interviste editoriali</li>
              <li>Case study aziendali</li>
            </ul>
          </div>
          <div>
            <div className="overline mb-6">Social</div>
            <div className="flex gap-3">
              <a href="#" data-testid="footer-instagram" className="w-11 h-11 rounded-full border border-white/15 hover:border-gold hover:text-gold flex items-center justify-center transition-colors">
                <Instagram strokeWidth={1.5} className="w-4 h-4" />
              </a>
              <a href="#" data-testid="footer-youtube" className="w-11 h-11 rounded-full border border-white/15 hover:border-gold hover:text-gold flex items-center justify-center transition-colors">
                <Youtube strokeWidth={1.5} className="w-4 h-4" />
              </a>
              <a href="mailto:Guzerat1998@gmail.com" data-testid="footer-mail" className="w-11 h-11 rounded-full border border-white/15 hover:border-gold hover:text-gold flex items-center justify-center transition-colors">
                <Mail strokeWidth={1.5} className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Massive brand type */}
        <div className="overflow-hidden border-t border-white/10 pt-10">
          <div className="font-display font-semibold tracking-tighter leading-none text-[18vw] text-white/95 select-none">
            FALCO<span className="text-gold"> POULO.</span>
          </div>
        </div>

        <div className="mt-10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Falco Poulo — Tutti i diritti riservati</span>
          <div className="flex gap-6">
            <a href="/admin/login" data-testid="footer-admin-link" className="hover:text-white">
              Area riservata
            </a>
            <a href="#" className="hover:text-white">
              Privacy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
